import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      take(1),
      map(isAuthenticated => {
        // Check Firebase auth first
        if (isAuthenticated) {
          return true;
        }

        // Fall back: check for org sessionToken (from email verification link)
        const orgId = route.paramMap.get('orgId');
        if (orgId) {
          const raw = localStorage.getItem(`org_session_${orgId}`);
          if (raw) {
            try {
              const session = JSON.parse(raw);
              if (session && typeof session.expiresAt === 'number' && session.expiresAt > Date.now()) {
                return true;
              }
            } catch {
              // Invalid JSON — fall through
            }
            // Session is invalid or expired — clean up
            localStorage.removeItem(`org_session_${orgId}`);
          }
        }

        // No auth found, redirect to login
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      })
    );
  }
}
